import React from 'react';
import { Link } from 'react-router-dom';
import { imageDomain, STYLE_TYPE } from '../../Utils/magicStrings';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../Swiper/Swiper';
import { RecommendWrapper, ItemWrapper, RecommendTag, RecommendInfoWrapper, RecommendTitle, RecommendContent, RecommendMainTitle } from './RecommendStyle';

export const Recommend = ({recommendItem, styleType}) => {
    if(!recommendItem || recommendItem.length === 0 ) return null;
    const items = recommendItem.map((item => (
        <Link to={`/detail/${item.innId}`} key={item.innId}>
            <ItemWrapper styleType={styleType}>
                <img data-src={`${imageDomain}/${item.coverImgUrl}`} alt='' className='lazyload'/>
                <RecommendTag styleType={styleType}>{item.tagList?.[0].substring(0,5)}</RecommendTag>
                <RecommendInfoWrapper styleType={styleType}>
                    <RecommendTitle styleType={styleType}>{`${item.title}-${item.name}`}</RecommendTitle>
                    <RecommendContent styleType={styleType}>{item.overview}</RecommendContent>
                </RecommendInfoWrapper>
            </ItemWrapper>
        </Link>
    )));
    return(
        <RecommendWrapper styleType={styleType} id='recommend'>
            <RecommendMainTitle styleType={styleType}>為您推薦</RecommendMainTitle>
            {styleType !== STYLE_TYPE.MOBILE && items}
            {styleType === STYLE_TYPE.MOBILE && 
                <Swiper
                    elements={items} 
                    step={74} 
                    isAutoPlay={false} 
                    isLoop={true} 
                    first={-60}
                    style2={{display: 'flex'}}
                    height={181} 
                    loopStep={3}
                    pointStyle={POINT_STYLE.NONE} 
                    arrowStyle={ARROW_STYLE.NONE}
                ></Swiper>}
        </RecommendWrapper>
    )
};